export const dataSourceAllMetric = [
  {
    text: 'Acquisition',
    value: 'Acquisition',
    keyValue: ['acquisition'],
  },
  {
    text: 'Airtime',
    value: 'Airtime',
    keyValue: ['airtime'],
  },
  {
    text: 'Avg CCV',
    value: 'Avg CCV',
    keyValue: ['avgCCV'],
  },
  {
    text: 'Avg Daily Playtime (mins)',
    value: 'Avg. daily playtime (mins)',
    keyValue: ['avg_daily_playtime'],
  },
  {
    text: 'Avg Daily Sessions',
    value: 'Avg. daily sessions',
    keyValue: ['avg_daily_sessions'],
  },
  {
    text: 'Avg Playtime Per Session (mins)',
    value: 'Avg. playtime / session (mins)',
    keyValue: ['avg_playtime_per_session'],
  },
  {
    text: 'Avg Monthly Playtime (hours)',
    value: 'Avg. monthly playtime (hours)',
    keyValue: ['avg_monthly_playtime', 'ampere_avg_monthly_playtime'],
  },
  {
    text: 'Avg Monthly Sessions',
    value: 'Avg. monthly sessions',
    keyValue: ['avg_monthly_sessions'],
  },
  {
    text: 'Avg Days Played',
    value: 'Avg. days played',
    keyValue: ['avg_days_played'],
  },
  {
    text: 'Calibrated DAU',
    value: 'Calibrated DAU',
    keyValue: ['Calibrated DAU'],
  },
  {
    text: 'Calibrated Downloads',
    value: 'Calibrated Downloads',
    keyValue: ['Calibrated Downloads'],
  },
  {
    text: 'Calibrated Revenue',
    value: 'Calibrated Revenue',
    keyValue: ['Calibrated Revenue'],
  },
  {
    text: 'Company Downloads',
    value: 'Company Downloads',
    keyValue: ['company_downloads', 'download_company'],
  },
  {
    text: 'Company Revenue',
    value: 'Company Revenue',
    keyValue: [
      'company_revenue',
      'digitalOfCompany',
      'revenueOfCompany',
      'revenue_company',
      'ofCompany',
    ],
  },
  {
    text: 'DAU',
    value: 'DAU',
    keyValue: ['dau', 'DAU', 'ampere_dau'],
  },
  {
    text: 'DAU Prediction',
    value: 'DAU Prediction',
  },
  {
    text: 'Digital ARPPU',
    value: 'Digital ARPPU',
    keyValue: ['digitalARPPU'],
  },
  {
    text: 'Digital AST',
    value: 'Digital AST',
    keyValue: ['ast'],
  },
  {
    text: 'Digital Revenue',
    value: 'Digital Revenue',
    keyValue: ['digitalRevenue', 'gsd_digitalRevenue', 'digital_revenue'],
  },
  {
    text: 'Digital Units',
    value: 'Digital Units',
    keyValue: ['units', 'gsd_digitalUnits'],
  },
  {
    text: 'Downloads',
    value: 'Downloads',
    keyValue: ['download', 'downloads', 'annie_download', 'sensor_download'],
  },
  {
    text: 'Monthly Downloads',
    value: 'Monthly Downloads',
  },
  {
    text: 'Downloads Prediction',
    value: 'Downloads Prediction',
  },
  {
    text: 'Hours Watched',
    value: 'Hours Watched',
    keyValue: ['hoursWatched'],
  },
  {
    text: 'Lifetime Player',
    value: 'Lifetime Player',
    keyValue: ['lifetime_player'],
  },
  {
    text: 'MAU',
    value: 'MAU',
    keyValue: ['mau', 'MAU', 'sensor_mau', 'annie_mau', 'ampere_mau'],
  },
  {
    text: 'MAU growth',
    value: 'MAU growth',
    keyValue: ['mau_growth'],
  },
  {
    text: 'MAU - new',
    value: 'MAU - new',
    keyValue: ['mau_new'],
  },
  {
    text: 'MAU - returning',
    value: 'MAU - returning',
    keyValue: ['mau_returning'],
  },
  {
    text: 'Most Played',
    value: 'Most Played',
    keyValue: ['xbox most played', 'most played'],
  },
  {
    text: 'New Release',
    value: 'New Release',
    keyValue: ['xbox new release', 'new release', 'nintendo new release'],
  },
  {
    text: 'New Trending',
    value: 'New Trending',
    keyValue: ['steam new and trending'],
  },
  {
    text: 'Peak CCV',
    value: 'Peak CCV',
    keyValue: ['peackCCV'],
  },
  {
    text: 'Physical Revenue',
    value: 'Physical Revenue',
    keyValue: ['gsd_physicalRevenue', 'physical_revenue', 'vg_insights_rev'],
  },
  {
    text: 'Physical Units',
    value: 'Physical Units',
    keyValue: ['physical_units', 'gsd_physicalUnits'],
  },
  {
    text: 'Player share',
    value: 'Player share',
    keyValue: ['player_share'],
  },
  {
    text: 'Predicted Heat',
    value: 'Predicted Heat',
  },
  {
    text: 'Revenue',
    value: 'Revenue',
    keyValue: ['revenue', 'est_revenue', 'annie_revenue', 'sensor_revenue'],
  },
  {
    text: 'Monthly Revenue',
    value: 'Monthly Revenue',
  },
  {
    text: 'Revenue Prediction',
    value: 'Revenue Prediction',
  },
  {
    text: 'RPD',
    value: 'RPD',
    keyValue: ['rpd'],
  },
  {
    text: 'Cumulative Revenue',
    value: 'Cumulative Revenue',
    keyValue: ['cumulative_revenue'],
  },
  {
    text: 'Cumulative Downloads',
    value: 'Cumulative Downloads',
    keyValue: ['cumulative_downloads'],
  },
  {
    text: 'Cross Mobile Usage',
    value: 'Cross Mobile Usage',
    keyValue: ['cross_usage', 'cross_app_usage'],
  },
  {
    text: 'Cross Mobile Affinity',
    value: 'Cross Mobile Affinity',
    keyValue: ['cross_affinity'],
  },
  {
    text: 'Steam PCU',
    value: 'Steam PCU',
    keyValue: ['pcu', 'PCU'],
  },
  {
    text: 'Steam ACU',
    value: 'Steam ACU',
    keyValue: ['acu', 'ACU'],
  },
  {
    text: 'Daily Wishlist',
    value: 'Daily Wishlist',
    keyValue: ['wishlists'],
  },
  {
    text: 'Lifetime Wishlist',
    value: 'Lifetime Wishlist',
    keyValue: ['wishlists_total'],
  },
  {
    text: 'Steam Units',
    value: 'Steam Units',
    keyValue: ['est_units', 'vg_insights_sold'],
  },
  {
    text: 'Streaming Viewers',
    value: 'Streaming Viewers',
  },
  {
    text: 'Stickiness',
    value: 'Stickiness',
    keyValue: ['stickiness', 'ampere_stickiness'],
  },
  {
    text: 'Top Free',
    value: 'Top Free',
    keyValue: ['appstore top free', 'googleplay top free', 'xbox top free', 'top free'],
  },
  {
    text: 'Top Grossing',
    value: 'Top Grossing',
    keyValue: ['appstore top grossing', 'googleplay top grossing'],
  },
  {
    text: 'Top New Free',
    value: 'Top New Free',
    keyValue: ['appstore top new free', 'googleplay top new free'],
  },
  {
    text: 'Top New Paid',
    value: 'Top New Paid',
    keyValue: ['appstore top new paid', 'googleplay top new paid', 'top paid'],
  },
  {
    text: 'Top Paid',
    value: 'Top Paid',
    keyValue: ['appstore top paid', 'googleplay top paid', 'xbox top paid'],
  },
  {
    text: 'Top Popular',
    value: 'Top Popular',
    keyValue: ['epic top popular', 'googleplay top popular', 'top popular'],
  },
  {
    text: 'Top Sellers',
    value: 'Top Sellers',
    keyValue: ['steam top sellers', 'epic top sellers', 'top sellers'],
  },
  {
    text: 'Top Wish Lists',
    value: 'Top Wish Lists',
    keyValue: ['steam top wish lists'],
  },
  {
    text: 'Total hours',
    value: 'Total hours',
    keyValue: ['total_hours'],
  },
  {
    text: 'Time Spent',
    value: 'Time Spent',
    keyValue: [
      'time_spent_0H',
      'time_spent_1H',
      'time_spent_5H',
      'time_spent_10H',
      'time_spent_25H',
      'time_spent_50H',
    ],
  },
  {
    text: 'Upcoming',
    value: 'Upcoming',
    keyValue: ['xbox upcoming'],
  },
  {
    text: 'WAU',
    value: 'WAU',
    keyValue: ['wau', 'WAU'],
  },
  {
    text: 'Best Sellers',
    value: 'Best Sellers',
    keyValue: ['nintendo best sellers'],
  },
  {
    text: 'Coming Soon',
    value: 'Coming Soon',
    keyValue: ['playstation coming soon', 'coming soon', 'nintendo coming soon'],
  },
  {
    text: 'Churn',
    value: 'Churn',
    keyValue: ['churn'],
  },
  {
    text: 'Best Selling',
    value: 'Best Selling',
    keyValue: ['best selling', 'playstation best selling'],
  },
  {
    text: 'Most Downloaded',
    value: 'Most Downloaded',
    keyValue: [
      'most downloaded',
      'ps5 most downloaded',
      'ps4 most downloaded',
      'playstation most downloaded',
    ],
  },

  {
    text: 'New Games',
    value: 'New Games',
    keyValue: ['playstation new games', 'new games'],
  },
  {
    text: 'Indies Games',
    value: 'Indies Games',
    keyValue: ['indies games', 'playstation indies games'],
  },
  {
    text: 'Free to Play',
    value: 'Free to Play',
    keyValue: ['free to play', 'free to play', 'playstation free to play'],
  },
  {
    text: 'Retention',
    value: 'Retention',
    keyValue: [
      'Retention',
      'retention_d1',
      'retention_d2',
      'retention_d4',
      'retention_d7',
      'retention_d14',
      'retention_d28',
    ],
  },
  {
    text: 'Sales',
    value: 'Sales',
    // Famitsu is temporarily unavailable in Intelligence pages.
    // keyValue: ['famitsu_sales', 'sales'],
    keyValue: ['sales'],
  },
  {
    text: 'Total Revenue',
    value: 'Total Revenue',
    keyValue: ['total revenue'],
  },
  {
    text: 'Total Units Sold',
    value: 'Total Units Sold',
  },
  {
    text: 'Price',
    value: 'Price',
    // Famitsu is temporarily unavailable in Intelligence pages.
    // keyValue: ['famitsu_price', 'est_price', 'price'],
    keyValue: ['est_price', 'price'],
  },
  {
    text: 'Weighted Price',
    value: 'Weighted Price',
    keyValue: ['weighted_price'],
  },
  {
    text: 'Players by country',
    value: 'Players by country',
    keyValue: ['players_by_country'],
  },
  {
    text: 'Avg. Playtime',
    value: 'Avg. Playtime',
    keyValue: ['playtime'],
  },
  {
    text: 'Followers',
    value: 'Followers',
    keyValue: ['followers'],
  },

  {
    text: 'Time Spent 0 - 1 hrs',
    value: 'Time Spent 0 - 1 hrs',
    keyValue: ['Time Spent 0 - 1 hrs'],
  },
  {
    text: 'Time Spent 1 - 5 hrs',
    value: 'Time Spent 1 - 5 hrs',
    keyValue: ['Time Spent 1 - 5 hrs'],
  },
  {
    text: 'Time Spent 5 - 10 hrs',
    value: 'Time Spent 5 - 10 hrs',
    keyValue: ['Time Spent 5 - 10 hrs'],
  },
  {
    text: 'Time Spent 10 - 25 hrs',
    value: 'Time Spent 10 - 25 hrs',
    keyValue: ['Time Spent 10 - 25 hrs'],
  },
  {
    text: 'Time Spent 25 - 50 hrs',
    value: 'Time Spent 25 - 50 hrs',
    keyValue: ['Time Spent 25 - 50 hrs'],
  },
  {
    text: 'Time Spent >50 hrs',
    value: 'Time Spent >50 hrs',
    keyValue: ['Time Spent >50 hrs'],
  },

  {
    text: 'Retention D1',
    value: 'Retention D1',
    keyValue: ['Retention D1'],
  },
  {
    text: 'Retention D2',
    value: 'Retention D2',
    keyValue: ['Retention D2'],
  },
  {
    text: 'Retention D4',
    value: 'Retention D4',
    keyValue: ['Retention D4'],
  },
  {
    text: 'Retention D7',
    value: 'Retention D7',
    keyValue: ['Retention D7'],
  },
  {
    text: 'Retention D14',
    value: 'Retention D14',
    keyValue: ['Retention D14'],
  },
  {
    text: 'Retention D28',
    value: 'Retention D28',
    keyValue: ['Retention D28'],
  },

  // 新增 ampere 指标
  // {
  //   text: 'MAU',
  //   value: 'MAU',
  //   keyValue: ['MAU'],
  // },
  // {
  //   text: 'Avg Monthly Playtime (hours)',
  //   value: 'Avg Monthly Playtime (hours)',
  //   keyValue: ['Avg Monthly Playtime (hours)'],
  // },
  {
    text: 'Acquisition Rate',
    value: 'Acquisition Rate',
    keyValue: ['ampere_acquisition_rate'],
  },
  // {
  //   text: 'Stickiness',
  //   value: 'Stickiness',
  //   keyValue: ['Stickiness'],
  // },
  {
    text: 'Lifetime Players',
    value: 'Lifetime Players',
    keyValue: ['ampere_lifetime_users'],
  },
  {
    text: 'Previous MAU',
    value: 'Previous MAU',
    keyValue: ['ampere_previous_mau'],
  },
  {
    text: 'Added Users',
    value: 'Added Users',
    keyValue: ['ampere_added_mau'],
  },
  {
    text: 'New Users',
    value: 'New Users',
    keyValue: ['ampere_new_mau', 'ampere_new_dau'],
  },
  {
    text: 'Retained Users',
    value: 'Retained Users',
    keyValue: ['ampere_retained_mau'],
  },
  {
    text: 'Churned Users',
    value: 'Churned Users',
    keyValue: ['ampere_churned_mau'],
  },
  // 重复指标不新增
  // {
  //   text: 'DAU',
  //   value: 'DAU',
  //   keyValue: ['DAU'],
  // },
  // {
  //   text: 'New Users',
  //   value: 'New Users',
  //   keyValue: ['New Users'],
  // },
  {
    text: 'Avg Daily Playtime (hours)',
    value: 'Avg Dailly Playtime (hours)',
    keyValue: ['ampere_avg_dailly_playtime'],
  },
  {
    text: 'D1',
    value: 'D1',
    keyValue: ['ampere_d1'],
  },
  {
    text: 'D7',
    value: 'D7',
    keyValue: ['ampere_d7'],
  },
  {
    text: 'D14',
    value: 'D14',
    keyValue: ['ampere_d14'],
  },
  {
    text: 'D28',
    value: 'D28',
    keyValue: ['ampere_d28'],
  },
  {
    text: 'D60',
    value: 'D60',
    keyValue: ['ampere_d60'],
  },
  {
    text: 'Rolling D1',
    value: 'Rolling D1',
    keyValue: ['ampere_rolling_d1'],
  },
  {
    text: 'Rolling D7',
    value: 'Rolling D7',
    keyValue: ['ampere_rolling_d7'],
  },
  {
    text: 'Rolling D14',
    value: 'Rolling D14',
    keyValue: ['ampere_rolling_d14'],
  },
  {
    text: 'Rolling D28',
    value: 'Rolling D28',
    keyValue: ['ampere_rolling_d28'],
  },
  {
    text: 'Rolling D60',
    value: 'Rolling D60',
    keyValue: ['ampere_rolling_d60'],
  },
];
